import * as R from "remeda";

import { dimensionValueStore } from "../../../../store/dimension.value";

import type { DimensionsData } from "./dimensions";

import type { BaseDataSourceConfiguration, DataSource } from ".";

export interface RequestParameterDataSourceConfiguration
    extends BaseDataSourceConfiguration {
    type: DataSource.REQUEST_PARAMETER;
    settings: RequestParametersDataSourceSettings;
}

export interface RequestParametersDataSourceSettings {
    keys: string[];
}

export const getRequestParameters = async (
    settings: RequestParametersDataSourceSettings,
): Promise<DimensionsData> => {
    const data = dimensionValueStore.getState();
    const requestParameters = R.pipe(
        data,
        R.pickBy((e) => R.isPlainObject(e)),
        R.values,
        R.filter(R.isDefined),
        R.map((e) => e.requestParameters),
        R.mergeAll,
        R.pick(settings.keys as any),
    );

    return requestParameters;
};
